import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCharacter } from '../context/CharacterContext';
import './DepotNotice.css';

// Bir eşya depoya düştüğünde: altta bildirim + ekrandaki depo düğmesine uçan ışık ve parlama.
// Depo düğmeleri data-depot-button özniteliğiyle işaretlidir (savaş ve envanter ekranı).
const DepotNotice = () => {
  const { t } = useTranslation('common');
  const { depotNotice } = useCharacter();
  const [visible, setVisible] = useState(null);
  const [orb, setOrb] = useState(null);
  const timers = useRef([]);

  useEffect(() => {
    if (!depotNotice) return undefined;
    // Önceki bildirimin zamanlayıcıları iptal edilince ışık ve parlama yarım kalmasın.
    timers.current.forEach(clearTimeout);
    timers.current = [];
    setOrb(null);
    document.querySelectorAll('.depot-btn--flash').forEach((el) => el.classList.remove('depot-btn--flash'));
    setVisible(depotNotice);
    timers.current.push(setTimeout(() => setVisible(null), 3200));

    const target = Array.from(document.querySelectorAll('[data-depot-button]'))
      .find((el) => el.offsetParent !== null);
    if (target) {
      const rect = target.getBoundingClientRect();
      const startX = window.innerWidth / 2;
      const startY = window.innerHeight - 80;
      setOrb({
        key: depotNotice.id,
        style: {
          '--orb-start-x': `${startX}px`,
          '--orb-start-y': `${startY}px`,
          '--orb-end-x': `${rect.left + rect.width / 2}px`,
          '--orb-end-y': `${rect.top + rect.height / 2}px`,
        },
      });
      timers.current.push(setTimeout(() => {
        setOrb(null);
        if (!target.isConnected) return;
        target.classList.remove('depot-btn--flash');
        // reflow ile animasyonu yeniden başlat
        void target.offsetWidth;
        target.classList.add('depot-btn--flash');
        timers.current.push(setTimeout(() => target.classList.remove('depot-btn--flash'), 1800));
      }, 750));
    }
    return undefined;
  }, [depotNotice]);

  useEffect(() => () => {
    timers.current.forEach(clearTimeout);
    document.querySelectorAll('.depot-btn--flash').forEach((el) => el.classList.remove('depot-btn--flash'));
  }, []);

  return (
    <>
      {orb ? <div key={orb.key} className="depot-notice-orb" style={orb.style} aria-hidden="true" /> : null}
      {visible ? (
        <div key={visible.id} className="depot-notice-toast" role="status" aria-live="polite">
          {t('depotItemAdded', { count: visible.added })}
        </div>
      ) : null}
    </>
  );
};

export default DepotNotice;
